import { Controller } from "@hotwired/stimulus"

// Manages adding and removing instances inside a repeatable section card.
//
// The section is rendered server-side with one card per existing instance + a hidden
// <template> containing one blank instance with the placeholder __INDEX__ in input
// names and ids. On "Add Another", the template is cloned, the placeholder is replaced
// with the next index, the new node is appended, and Stimulus auto-connects any
// controllers inside (signature, qr-scanner, edit-full-photo, product-installer).
export default class extends Controller {
  static targets = ["instances", "instance", "template", "addBtn", "removeBtn", "instanceLabel"]
  static values = {
    key: String,
    min: Number,
    max: Number,
    nextIndex: Number
  }

  connect() {
    this.refreshButtons()
  }

  addInstance(event) {
    event.preventDefault()

    if (this.maxValue >= 0 && this.instanceTargets.length >= this.maxValue) return

    const html = this.templateTarget.innerHTML
      .replaceAll("__INDEX__", String(this.nextIndexValue))
      .replaceAll("__LABEL__", String(this.instanceTargets.length + 1))

    const tmp = document.createElement("div")
    tmp.innerHTML = html.trim()
    const node = tmp.firstElementChild
    this.instancesTarget.appendChild(node)

    this.nextIndexValue = this.nextIndexValue + 1
    this.refreshLabels()
    this.refreshButtons()
  }

  removeInstance(event) {
    event.preventDefault()

    if (this.instanceTargets.length <= Math.max(1, this.minValue)) return

    const instance = event.currentTarget.closest("[data-repeatable-section-target='instance']")
    if (instance) instance.remove()

    this.refreshLabels()
    this.refreshButtons()
  }

  refreshLabels() {
    this.instanceTargets.forEach((el, idx) => {
      const label = el.querySelector("[data-repeatable-section-target='instanceLabel']")
      if (label) label.textContent = `#${idx + 1}`
    })
  }

  refreshButtons() {
    const count = this.instanceTargets.length
    const atMin = count <= Math.max(1, this.minValue)
    const atMax = this.maxValue >= 0 && count >= this.maxValue

    if (this.hasAddBtnTarget) this.addBtnTarget.disabled = atMax
    this.removeBtnTargets.forEach((btn) => { btn.disabled = atMin })
  }
}
